import React from "react";

function Research() {
  return (
    <div>
      <h1>Ingredients</h1>
      <p>Regenerative Actives (Cosmetic) | Bioactive Compounds (Pharma) | Nutraceutical Extracts</p>
    </div>
  );
}

export default Research;
